/**
 * Sprint Redesign v1 · Issue 10 (Do 03.09.2026, 23:00).
 *
 * Zentrale Route-Wahl für den Fokustyp-Test in Abhängigkeit vom Tier des Users:
 *   Free / cancelled / expired  → Quick-Check (5 Fragen, 2 Minuten)
 *   Pro Solo Monatlich / Jährlich → Großer Primärfokustyp-Test (20 Fragen)
 *   PowerPaket-Lifetime            → Großer Test (Bugfix Sa 14.09.2026)
 *
 * Ein-Anlauf-API damit Dashboard, Profil und Empty-State konsistent das
 * richtige Ziel ansteuern.
 */

// Sprint V101.h (So 20.09.2026, Andreas) — Router auf V100 QuickCheck (Smiley-
// Skala) umgestellt. Alter Pionier-Quick-Check-Pfad wurde noch von Dashboard,
// Profil, Empty-State und Post-DOI-Weiterleitung angesteuert, obwohl der
// V100-Test seit Sprint V100 die neue Free-Standard-Strecke ist.
const QUICK_CHECK_ROUTE = "/quickcheck";
const GROSSER_TEST_ROUTE = "/dashboard/pro-analyse";

const PRO_TIERS = new Set([
  "pro_solo_monthly",
  "pro_solo_annual",
  "power_paket_onetime",  // Sprint V36 Bugfix — PowerPaket ist Vollzugang, nicht Quick-Check.
]);

/**
 * Liefert die passende Test-Route für den aktuellen User.
 * PowerPaket-Lifetime wird zusätzlich über das Flag `powerpaket_lifetime`
 * erkannt (funktioniert auch, wenn der Nutzer gleichzeitig auf einem
 * anderen Tier steht — was durch V30-Retention-Grants passieren kann).
 * @param {object|null|undefined} user
 * @returns {string}
 */
export function getFokustypTestRoute(user) {
  if (!user) return QUICK_CHECK_ROUTE;
  const tier = user.license_tier;
  if (PRO_TIERS.has(tier)) return GROSSER_TEST_ROUTE;
  if (user.powerpaket_lifetime === true) return GROSSER_TEST_ROUTE;
  return QUICK_CHECK_ROUTE;
}

export const FOKUSTYP_TEST_ROUTES = {
  quick: QUICK_CHECK_ROUTE,
  gross: GROSSER_TEST_ROUTE,
};
